export const heartRunnerLoginState = {
    userName: "",
    password: "",
    isLoading: false,
    message: "",
    loginStatus: 0,
    authTokenId: "",
    adminId: 0,
    organizationId: 0,
    adminInfo:'',
    UserCategoryId:3
}